import React, { Component } from "react";
import Modal from "../Modal/Modal";
import ShareLinks from "../ShareLinks/ShareLinks";
import RichText from "../RichText/RichText";

class VotingCompleteModal extends Component {
  render() {
    const { textBody } = this.props
    // Small hack to remove the /vote portion of the url and just return competition slug
    const shareUrl = window.location.href.split("/vote/")[0];
    return (
      <Modal handleDismiss={this.props.handleDismiss}>
        <div className="voting-complete-modal">
          <h3>Your votes are in!</h3>
          { textBody ? <RichText content={textBody} /> : null }
          <ShareLinks url={shareUrl} hideCaption />
        </div>
      </Modal>
    );
  }
}

export default VotingCompleteModal;



// WEBPACK FOOTER //
// ./src/components/VotingCompleteModal/VotingCompleteModal.js